import { getOffers, addOffer, updateOffer, deleteOffer } from "@/api/offers";
import { ref } from "vue";

const state = {
    offers: ref({}),
    isLoading: ref(false),
    lists: ref([])
};

const actions = {
    async fetchOffers({ commit }, page) {
        try {
            const response = await getOffers();
            commit('SET_OFFERS', response.data);
        } catch (error) {
            console.log(error);
        }
    },

    async addNewOffer({ commit }, offer) {
        try {
            const res = await addOffer(offer);
            commit('ADD_OFFER', res.data.offer);
            return res;
        } catch (error) {
            console.log(error);
            throw error;
        }
    },

    async updateExistingOffer({ commit }, offer) {
        try {
            const res = await updateOffer(offer);
            commit('UPDATE_OFFER', res.data.offer);
            return res;
        } catch (error) {
            console.log(error);
            throw error;
        }
    },

    async deleteExistingOffer({ commit }, data) {
        try {
            await deleteOffer(data);
            commit('DELETE_OFFER', data.id);
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
};

const mutations = {
    SET_OFFERS(state, offers) {
        state.offers = offers;
        state.offers = state.offers.map(offer => ({
            ...offer,
            is_edit_active: false
        }));
    },

    ADD_OFFER(state, offer) {
        state.offers.unshift({
            ...offer,
            is_edit_active: false
        });
    },

    UPDATE_OFFER(state, updatedOffer) {
        state.offers = state.offers.map(offer => 
            offer.id === updatedOffer.id ? updatedOffer : offer
        );
    },

    DELETE_OFFER(state, id) {
        state.offers = state.offers.filter(offer => offer.id !== id);
    }
};

const getters = {
    getOffers: (state) => state.offers,
    isLoading: (state) => state.isLoading
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
